import { render, staticRenderFns } from "./VouchersCaroussel.vue?vue&type=template&id=2b9536fe"
import script from "./VouchersCaroussel.vue?vue&type=script&lang=js"
export * from "./VouchersCaroussel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports